/**
 * @desc getRolesByAppDomainCode
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<defs.appCenter.AppRoleResponseDto>>;
export function request(
  params: API.appCenter.appRoleFacadeImpl.getRolesByAppDomainCode.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/app/roles`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
